import {
  GET_RECOMMENDED_MEALS_FOR_BASKET_REQUEST,
  GET_RECOMMENDED_MEALS_FOR_BASKET_RESPONSE,
  GET_RECOMMENDED_MEALS_FOR_BASKET_ERROR,
} from 'actions/recommendedMeals';

const initialState = {};

const getStageKey = extrasStage => (extrasStage ? 'stageStep2' : 'stageStep1');

export default (state = initialState, action) => {
  const stageKey = getStageKey(action.params?.extrasStage);

  switch (action.type) {
    case GET_RECOMMENDED_MEALS_FOR_BASKET_REQUEST:
      return {
        ...state,
        [action.params.menuSlug]: {
          ...state[action.params.menuSlug],
          [stageKey]: {
            isError: false,
            isLoading: true,
          },
        },
      };
    case GET_RECOMMENDED_MEALS_FOR_BASKET_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: {
          ...state[action.params.menuSlug],
          [stageKey]: {
            meals: action.response.meals,
            isLoading: false,
          },
        },
      };
    case GET_RECOMMENDED_MEALS_FOR_BASKET_ERROR:
      return {
        ...state,
        [action.params.menuSlug]: {
          ...state[action.params.menuSlug],
          [stageKey]: {
            isError: true,
            isLoading: false,
          },
        },
      };
    default:
      return state;
  }
};

export const selectRecommendedMealsForBasket = (state, menuSlug, extrasStage = false) => {
  const stageKey = getStageKey(extrasStage);
  return state.recommendedMeals[menuSlug]?.[stageKey]?.meals || [];
};

export const selectRecommendedMealsForBasketIsError = (state, menuSlug, extrasStage = false) => {
  const stageKey = getStageKey(extrasStage);
  return state.recommendedMeals[menuSlug]?.[stageKey]?.isError || false;
};

export const selectRecommendedMealsForBasketIsLoading = (state, menuSlug, extrasStage = false) => {
  const stageKey = getStageKey(extrasStage);
  const isLoading = state.recommendedMeals[menuSlug]?.[stageKey]?.isLoading;
  if (isLoading === undefined) return { isLoading: true, requestInitialized: false };
  return { isLoading, requestInitialized: true };
};
